import { RoutePaths } from "constants/RoutePaths";
import { Button, Divider, Menu, MenuItem, Stack, Typography, useTheme } from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import React from "react";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from "react-i18next";
import { useAuthContext } from "hooks/useAuthContext";
import { useLogout } from "hooks/useLogout";
import { createColorFilteredComponent } from "helpers/styledHelpers";

const StyledUserName = createColorFilteredComponent<{ $color: string }>(Typography)(({ $color }) => ({
  color: $color,
  textTransform: 'none',
  whiteSpace: 'nowrap'
}));

const StyledArrowIcon = createColorFilteredComponent<{ $color: string }>(KeyboardArrowDownIcon)(({ $color }) => ({
  color: $color
}));

export const UserNameContextMenu = () => {
    const { userState } = useAuthContext();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const logout = useLogout();
    const theme = useTheme();
    
    const handleLogoutClick = async () => {
        await logout();
        navigate(RoutePaths.LOGIN);
    }
    
    return !userState.user.userId ? null : <PopupState variant="popover" popupId="user-context-popup-menu">
    {(popupState) => (
        <React.Fragment>
        <Button {...bindTrigger(popupState)}>
            <Stack direction='row'>
                <StyledUserName variant='subtitle1' $color={theme.palette.black.main}>{userState.user.selectedWorkspace.userDisplayName}</StyledUserName>
                <StyledArrowIcon $color={theme.palette.black.main}/>
            </Stack>
        </Button>
        <Menu {...bindMenu(popupState)}>
            <Stack padding={theme.spacing(2)}>
                <MenuItem onClick={() => { navigate(RoutePaths.PROFILE); popupState.close()}}>{t('navbar.profile')}</MenuItem>
                <Divider />
                <MenuItem onClick={handleLogoutClick}>{t('navbar.logout')}</MenuItem>
            </Stack>            
        </Menu>
        </React.Fragment>
    )}
    </PopupState>
}